import { render, staticRenderFns } from "./browserError.vue?vue&type=template&id=3c1870a9&scoped=true&"
import script from "./browserError.vue?vue&type=script&lang=js&"
export * from "./browserError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1870a9",
  null
  
)

export default component.exports